import { render, staticRenderFns } from "./examPlace.vue?vue&type=template&id=3d0ebfc7&scoped=true"
import script from "./examPlace.vue?vue&type=script&lang=js"
export * from "./examPlace.vue?vue&type=script&lang=js"
import style0 from "./examPlace.vue?vue&type=style&index=0&id=3d0ebfc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ebfc7",
  null
  
)

export default component.exports